<template>
  <transition name="FadeIn">
    <div
      class="Popup Politics"
      v-if="forms.politicsPopup.opened"
      @click.self="managePopupState({ popup: 'politicsPopup', _state: false })"
    >
      <div class="Politics__inner">
        <div
          class="Popup__close"
          @click="managePopupState({ popup: 'politicsPopup', _state: false })"
        >
          <span aria-label="Close Popup">&times;</span>
        </div>
        <div class="Politics__content">
          <div class="Politics__caption">
            <h3>{{ $t("PRIVACY_POLICY.TITLE") }}</h3>
          </div>
          <ol class="Politics__list">
            <li>
              <span>{{ $t("PRIVACY_POLICY.LIST.1.TITLE") }}</span>
              <p>{{ $t("PRIVACY_POLICY.LIST.1.SUBTITLE") }}</p>
              <ol class="Politics__list">
                <li>{{ $t("PRIVACY_POLICY.LIST.1.SUBLIST.1") }}</li>
                <i18n tag="li" path="PRIVACY_POLICY.LIST.1.SUBLIST.2">
                  <template #sitename>
                    <a href="https://helpcenter.life">
                      {{ $t("PRIVACY_POLICY.SITENAME") }} </a
                    >.
                  </template>
                </i18n>
              </ol>
            </li>
            <li>
              <span>{{ $t("PRIVACY_POLICY.LIST.2.TITLE") }}</span>
              <ol class="Politics__list">
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.1") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.2") }}</li>
                <i18n tag="li" path="PRIVACY_POLICY.LIST.2.SUBLIST.3">
                  <template #sitename>
                    <a href="https://helpcenter.life">
                      {{ $t("PRIVACY_POLICY.SITENAME") }} </a
                    >;
                  </template>
                </i18n>
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.4") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.5") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.6") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.7") }}</li>
                <i18n tag="li" path="PRIVACY_POLICY.LIST.2.SUBLIST.8">
                  <template #sitename>
                    <a href="https://helpcenter.life">
                      {{ $t("PRIVACY_POLICY.SITENAME") }} </a
                    >;
                  </template>
                </i18n>
                <i18n tag="li" path="PRIVACY_POLICY.LIST.2.SUBLIST.9">
                  <template #sitename>
                    <a href="https://helpcenter.life">
                      {{ $t("PRIVACY_POLICY.SITENAME") }} </a
                    >;
                  </template>
                </i18n>
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.10") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.11") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.12") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.2.SUBLIST.13") }}</li>
              </ol>
            </li>
            <li>
              <span>{{ $t("PRIVACY_POLICY.LIST.3.TITLE") }}</span>
              <ol class="Politics__list">
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.1") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.2") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.3") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.4") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.5") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.6") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.7") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.8") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.9") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.10") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.11") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.3.SUBLIST.12") }}</li>
              </ol>
            </li>
            <li>
              <span>{{ $t("PRIVACY_POLICY.LIST.4.TITLE") }}</span>
              <ol class="Politics__list">
                <li>{{ $t("PRIVACY_POLICY.LIST.4.SUBLIST.1") }}</li>
                <i18n tag="li" path="PRIVACY_POLICY.LIST.4.SUBLIST.2">
                  <template #mailto>
                    <a
                      href="mailto:belyakov@sailet.pro"
                      target="_blank"
                      rel="noopener nofollow"
                      >{{ $t("PRIVACY_POLICY.MAILTO") }}</a
                    >;
                  </template>
                </i18n>
                <li>{{ $t("PRIVACY_POLICY.LIST.4.SUBLIST.3") }}</li>
              </ol>
            </li>
            <li>
              <span>{{ $t("PRIVACY_POLICY.LIST.5.TITLE") }}</span>
              <ol class="Politics__list">
                <i18n tag="li" path="PRIVACY_POLICY.LIST.5.SUBLIST.1">
                  <template #sitename>
                    <a href="https://helpcenter.life">
                      {{ $t("PRIVACY_POLICY.SITENAME") }} </a
                    >;
                  </template>
                </i18n>
                <li>{{ $t("PRIVACY_POLICY.LIST.5.SUBLIST.2") }}</li>
              </ol>
            </li>
            <li>
              <span>{{ $t("PRIVACY_POLICY.LIST.6.TITLE") }}</span>
              <p>{{ $t("PRIVACY_POLICY.LIST.6.SUBTITLE") }}</p>
              <ol class="Politics__list">
                <li>{{ $t("PRIVACY_POLICY.LIST.6.SUBLIST.1") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.6.SUBLIST.2") }}</li>
                <i18n tag="li" path="PRIVACY_POLICY.LIST.6.SUBLIST.3">
                  <template #mailto>
                    <a
                      href="mailto:belyakov@sailet.pro"
                      target="_blank"
                      rel="noopener nofollow"
                      >{{ $t("PRIVACY_POLICY.MAILTO") }}</a
                    >;
                  </template>
                </i18n>
                <i18n tag="li" path="PRIVACY_POLICY.LIST.6.SUBLIST.4">
                  <template #mailto>
                    <a
                      href="mailto:belyakov@sailet.pro"
                      target="_blank"
                      rel="noopener nofollow"
                      >{{ $t("PRIVACY_POLICY.MAILTO") }}</a
                    >;
                  </template>
                </i18n>
              </ol>
            </li>
            <li>
              <span>{{ $t("PRIVACY_POLICY.LIST.7.TITLE") }}</span>
              <ol class="Politics__list">
                <li>{{ $t("PRIVACY_POLICY.LIST.7.SUBLIST.1") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.7.SUBLIST.2") }}</li>
              </ol>
            </li>
            <li>
              <span>{{ $t("PRIVACY_POLICY.LIST.8.TITLE") }}</span>
              <ol class="Politics__list">
                <i18n tag="li" path="PRIVACY_POLICY.LIST.8.SUBLIST.1">
                  <template #mailto>
                    <a
                      href="mailto:belyakov@sailet.pro"
                      target="_blank"
                      rel="noopener nofollow"
                      >{{ $t("PRIVACY_POLICY.MAILTO") }}</a
                    >;
                  </template>
                </i18n>
                <li>{{ $t("PRIVACY_POLICY.LIST.8.SUBLIST.2") }}</li>
                <li>{{ $t("PRIVACY_POLICY.LIST.8.SUBLIST.3") }}</li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "Politics",
  methods: {
    ...mapMutations(["managePopupState"])
  },
  computed: {
    ...mapGetters(["forms"])
  }
};
</script>
